import { useTheme } from '@mui/material/styles';

function useDarkMode() {
  const theme = useTheme();

  return theme.palette.mode === 'dark';
}

export default useDarkMode;
